export enum CreateRoundPlacements{
    START,
    END
}